<script>
import { plansof } from '@/utils/chain';
import { mapGetters } from 'vuex';
export default {
  props: {
    type: String,
  },
  computed: {
    ...mapGetters(['isProrated', 'isProratedLoading', 'getSelectedPlans', 'boughtPlans']),
    mx_is() {
      return this.isProrated;
    },
    mx_loading() {
      return this.isProratedLoading;
    },
    // only for a specific type
    mx_cartPlan() {
      return plansof(this.getSelectedPlans).type(this.type).get(0);
    },
    // only for a specific type
    mx_boughtPlan() {
      const category = this.mx_cartPlan.category;
      return plansof(this.boughtPlans).type(this.type).category(category).get(0);
    },
    mx_isSingleIncreaseLicense(){
      if (this.getSelectedPlans.length !== 1) return false;
      const cartPlan = this.getSelectedPlans[0];
      const boughtPlan = this.boughtPlans.find(x => {
        return [cartPlan?.plan_code, cartPlan?.priceChangeMappingPlanCode].includes(x.plan_code)
      });
      if(!boughtPlan) return false;
      return (cartPlan.cartInfo?.selected_number??0) > (boughtPlan.cartInfo?.selected_number??0);
    },
  },
};
</script>